import React, { useEffect, useRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import CommonTags, { autoResizeTextArea } from './commonTags';

export const MeetingTopicTextArea = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const { meetingObj, currentUser, resetTopicTag } = props;
  const type = 'topic';

  const getReturnTag = (tagId) => props.onTopicTag(tagId);

  const openTopicArea = () => {
    const eleId = `meeting_topic_${meetingObj.id}`;
    props.onDoneBtn(true);
    // TODO: initializeMeetingEditor is an example of global variable
    initializeMeetingEditor(eleId, props.onSubmit);
    autoResizeTextArea({ eleId: `#meeting_topic_${meetingObj.id}` });

    // below setTimeout is a pre-existing hack and I don't like it :)
    setTimeout(() => {
      // TODO: Example of JQuery. Future refactor
      $(`#meeting_topic_${meetingObj.id}`).removeProp('disabled');
      $(`#meeting_topic_${meetingObj.id}`).removeAttr('disabled');
      $(`#${eleId}`).html('');
    }, 200);
  };

  useEffect(() => {
    if (resetTopicTag == 3) {
      props.clearGlobalValueBta();
    }
  }, [resetTopicTag]);

  return (
    <div
      ref={wrapperRef}
      className="textSecFirst displayCell"
      style={{ borderRight: '5px solid #ECEFF1', verticalAlign: 'top' }}
    >
      <div className="oneonone-expand ">
        <div className="wb-textarea-container">
          <div className="type-enter-box topicContainer">
            <div className="width100  meeting-topic-add">
              <CommonTags
                owner={currentUser.id}
                key="topic_add"
                meeting={meetingObj}
                userPermission={props.userPermission}
                currentUser={currentUser}
                tag={props.tag}
                type={type}
                saveTags={props.saveTags}
                getReturnTag={getReturnTag}
                emptyArea
              />
              <div
                className="meetingagendatextboxExpand meetingagendatextbox meetingagendatextboxnew meetingagendatextboxempty "
                id={`meeting_topic_${meetingObj.id}`}
                placeholder={t('Add topics here')}
                ref={ref}
                data-enable-quickadd="true"
                onKeyDown={event => props.onSubmit(event, false, false)}
                onClick={openTopicArea}
                data-attr-topicheader="true"
                style={{ width: '88%', marginLeft: '36px' }}
              />
              <input
                type="hidden"
                value={props.takeTopicId}
                name="emptyTopicId"
              />
            </div>
          </div>
        </div>
      </div>
      {props.showDoneBtn ? (
        <button
          onClick={props.onSubmit}
          className="btn-circle subTopicBtn"
        >
          <span className="icon icon-outline-check-24px-blue" />
        </button>
      ) : (
        ''
      )}
    </div>
  );
})
